module.exports = __webpack_public_path__ + "cab54dc1868df658804ee54ea27c334b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/chipotle_2023_chart.png
// module id = 1654
// module chunks = 0